<!-- 工作台 -->
<template>
  <div>
    <div class="form-main">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="120px"
        class="formData"
      >
        <div>
          <el-form-item label="价格段" prop="PriceLevelId">
            <el-select
              v-model="formData.PriceLevelId"
              remote
              filterable
              placeholder="请选择价格段"
            >
              <el-option
                v-for="item in levelList"
                :key="item.LevelId"
                :label="item.LevelName"
                :value="item.LevelId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="cancel()">关闭</el-button>
        <el-button class="btn-primary" @click="submitLevelForm">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["memberId", "priceLevelId"],
  name: "",
  data() {
    return {
      formData: {
        UnionId: this.$util.getLocalStorage("currentUnion"),
        PriceLevelId: "",
        MemberId: "",
      },
      levelList: [],
      rules: {
        PriceLevelId: [
          {
            required: true,
            message: "价格段必选",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.priceLevelId) this.formData.PriceLevelId = this.priceLevelId;
    if (this.memberId) {
      this.formData.MemberId = this.memberId;
      this.getLevelData();
    }
  },
  methods: {
    getLevelData() {
      let that = this;
      that.loading = true;
      that.$util
        .axiosGet({
          url: "/api/EntpUnionGoods/GetUnionPriceLevelList",
          data: { UnionId: this.formData.UnionId },
          hideLoading: true,
        })
        .then((res) => {
          let data = res.data;
          that.levelList = data;
        })
        .finally(() => {
          that.loading = false;
        });
    },
    // 提交表单
    submitLevelForm() {
      let that = this;
      that.$refs.formData.validate((valid) => {
        if (valid) {
          let url = "/api/EntpUnions/SubmitPriceLevelData";
          that.$util
            .axiosPost({
              url: url,
              data: that.formData,
            })
            .then(() => {
              that.$util.successMsg("成功分配价格段");
              that.$emit("closeDialog", true);
            })
            .catch(() => {});
        } else {
          this.$util.errorMsg("校验不通过");
          return false;
        }
      });
    },
    cancel() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style lang="less" scoped>
.form-value {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  width: 100%;
}
.form-column {
  width: 33.33%;
}
.dialog-footer {
  text-align: right;
}
</style>
